module.exports = __webpack_public_path__ + "img/barrabonita.365d8565.png";